import React from 'react';
import InputField from '../Forms/Input/InputField';
import { TaxpayerAuthenticationConfigDTO } from '../../types/hacienda/TaxpayerAuthenticationTypes';

interface TaxpayerAuthenticationFormProps {
  form: TaxpayerAuthenticationConfigDTO;
  errors?: Record<string, string>;
  isLoading: boolean;
  isSubmitting: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSave: () => void;
}

const TaxpayerAuthenticationFormComponent: React.FC<TaxpayerAuthenticationFormProps> = ({
  form,
  errors = {},
  isLoading,
  isSubmitting,
  onChange,
  onSave,
}) => {
  return (
    <div className="space-y-10 p-4 px-4 py-5">
      {/* 🔹 Descripción */}
      <div className="text-gray-600 dark:text-gray-300 mb-6 space-y-4 text-sm">
        <p>
          Esta configuración permite <strong>autenticarse</strong> ante el Ministerio de Hacienda y
          <strong> firmar</strong> los Documentos Tributarios Electrónicos (DTE).
        </p>
        <p>
          El <strong>NIT del contribuyente</strong> se obtiene automáticamente desde la configuración de la empresa.
        </p>
      </div>

      {/* 🔹 Campos */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
        <InputField
          label="NIT del Contribuyente"
          name="taxId"
          value={form.taxId}
          onChange={onChange}
          error={errors.taxId}
          iconKey="idCard"
          placeholder="Ej. 13161710931014"
          type="text"
          disabled
        />

        <InputField
          label="API Key (Autenticación MH)"
          name="apiKey"
          type="password"
          value={form.apiKey}
          onChange={onChange}
          error={errors.apiKey}
          iconKey="key"
          placeholder="Clave proporcionada para autenticarse en Hacienda"
        />

        <InputField
          label="Contraseña de Llave Privada (.p12)"
          name="privateKeyPassword"
          type="password"
          value={form.privateKeyPassword}
          onChange={onChange}
          error={errors.privateKeyPassword}
          iconKey="lock"
          placeholder="Contraseña para firmar DTE"
        />
      </div>

      {/* 🔹 Botón Guardar */}
      <div className="mt-6">
        <button
          onClick={onSave}
          disabled={isSubmitting || isLoading}
          className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-60"
        >
          {isSubmitting ? 'Guardando...' : 'Guardar Configuración'}
        </button>
      </div>
    </div>
  );
};

export default TaxpayerAuthenticationFormComponent;
